export var CallTypes;
(function (CallTypes) {
    CallTypes["Agent"] = "agent";
    CallTypes["Office"] = "office";
    CallTypes["Agency"] = "agency";
})(CallTypes || (CallTypes = {}));
